import { createAction } from 'redux-actions';

import { createAlertAction } from 'store/alerts';

import {
  UPDATE_REPORTS,
  UPDATE_REPORT,
  RESET_REPORTS,
  UPDATE_FILTER_STATUS,
  UPDATE_FILTER_SEARCH,
  UPDATE_SORT,
  UPDATE_PAGINATION,
  UPDATE_RECEIVER_TYPE,
  RESET_FILTER,
  FETCH_REPORTS,
  FETCH_REPORTS_STATUS,
  FETCH_REPORT,
  SAVE_REPORT,
  SAVE_REPORT_DEBOUNCE,
  SAVE_EXTERN_REPORT,
  CREATE_REPORTS_ARCHIVE,
  UPLOAD_EXCEL_FILE,
} from './types';

export const updateReports = createAction(UPDATE_REPORTS);
export const updateReport = createAction(UPDATE_REPORT);
export const resetReports = createAction(RESET_REPORTS);

export const updateStatus = createAction(UPDATE_FILTER_STATUS);
export const updateSearch = createAction(UPDATE_FILTER_SEARCH);
export const updateSort = createAction(UPDATE_SORT);
export const updatePagination = createAction(UPDATE_PAGINATION);
export const updateReceiverType = createAction(UPDATE_RECEIVER_TYPE);
export const resetFilter = createAction(RESET_FILTER);

export const fetchReports = createAlertAction(FETCH_REPORTS);
export const fetchReportsStatus = createAlertAction(FETCH_REPORTS_STATUS);
export const fetchReport = createAlertAction(FETCH_REPORT);
export const saveReport = createAlertAction(SAVE_REPORT);
export const saveReportDebounce = createAlertAction(SAVE_REPORT_DEBOUNCE);
export const saveExternReport = createAlertAction(SAVE_EXTERN_REPORT);
export const createReportsArchive = createAlertAction(CREATE_REPORTS_ARCHIVE);
export const uploadExcelFile = createAlertAction(UPLOAD_EXCEL_FILE);
